export const sanitizeEmail = (email: string = ''): string => email ? email.toLowerCase().trim() : null;
